// // components/EditRequestDialog.tsx
// import React from "react";
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Typography,
//     IconButton,
//     TextField,
//     Button,
//     Grid,
//     Box,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";


// interface EditRequestDialogProps {
//     open: boolean;
//     onClose: () => void;
//     onSubmit: (request: string) => void;
//     info: {
//         firstName: string;
//         lastName: string;
//         mobile: string;
//         email: string;
//         team: string;
//         access: string;
//         owner: string;
//     };
//     requestText: string;
//     setRequestText: (value: string) => void;
// }

// const EditRequest: React.FC<EditRequestDialogProps> = ({
//     open,
//     onClose,
//     onSubmit,
//     info,
//     requestText,
//     setRequestText,
// }) => {
//     return (
//         <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm"
//             PaperProps={{
//                 sx: {
//                     width: "800px !mportant",
//                     maxWidth: "800px !important",
//                     borderRadius: "10px",

//                 },
//             }}>
//             <DialogTitle
//                 sx={{
//                     fontWeight: 500,
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     fontSize: "24px"
//                 }}
//             >
//                 Edit request for personal information
//                 <IconButton onClick={onClose}>
//                     <CloseIcon sx={{ width: "15px", border: "1px solid #000", borderRadius: "50%", height: "15px", color: "#000" }} />
//                 </IconButton>
//             </DialogTitle>

//             <DialogContent>
//                 <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                         <Typography variant="body2" sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}>First Name: <b>{info.firstName}</b></Typography>
//                         <Typography variant="body2" sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}>Mobile Number: <b>{info.mobile}</b></Typography>
//                         <Typography variant="body2" sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}>Team: <b>{info.team}</b></Typography>
//                         <Typography variant="body2" sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}>Module Owner: <b>{info.owner}</b></Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                         <Typography variant="body2" sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}>Last Name: <b>{info.lastName}</b></Typography>
//                         <Typography variant="body2" sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}>Company Email: <b>{info.email}</b></Typography>
//                         <Typography variant="body2" sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}>Module Access: <b>{info.access}</b></Typography>
//                     </Grid>
//                 </Grid>

//                 <Box mt={3}>
//                     <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                         <Typography variant="body2" mb={1}>
//                             Write your request*
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                             {requestText.length}/200
//                         </Typography>
//                     </Box>
//                     <TextField
//                         fullWidth
//                         multiline
//                         minRows={4}
//                         placeholder="Please list the edits you would like to request here."
//                         value={requestText}
//                         inputProps={{ maxLength: 200 }}
//                         onChange={(e) => setRequestText(e.target.value)}
//                         sx={{ background: "#F3F4F6" }}
//                     />

//                 </Box>
//             </DialogContent>

//             <DialogActions sx={{ px: 3, pb: 2, display: "flex", justifyContent: "space-between", width: "100%" }}>
//                 <Button variant="outlined" onClick={onClose} sx={{ width: "50%", color: "#7D7E7F", borderColor: "1px solid #7D7E7F" }}>
//                     Back
//                 </Button>
//                 <Button
//                     variant="contained"
//                     disabled={!requestText.trim()}
//                     onClick={() => onSubmit(requestText)}
//                     sx={{ width: "50%", background: "#C8172F" }}

//                 >
//                     Submit
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default EditRequest;








// // import React, { useState } from "react";
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Typography,
// //   IconButton,
// //   TextField,
// //   Button,
// //   Grid,
// //   Box,
// // } from "@mui/material";
// // import CloseIcon from "@mui/icons-material/Close";
// // import { getrequestdata } from "./api"; // Adjust path to your api.ts
// // import { getToken } from "../../utils/utils";

// // interface RequestData {
// //   admin_id: string;
// //   req_desc: string;
// // }

// // interface EditRequestDialogProps {
// //   open: boolean;
// //   onClose: () => void;
// //   onSubmit: (request: string) => void;
// //   adminId: string; // Receive adminId prop
// //   info: {
// //     firstName: string;
// //     lastName: string;
// //     mobile: string;
// //     email: string;
// //     team: string;
// //     access: string;
// //     owner: string;
// //   };
// //   requestText: string;
// //   setRequestText: (value: string) => void;
// // }

// // const EditRequest: React.FC<EditRequestDialogProps> = ({
// //   open,
// //   onClose,
// //   onSubmit,
// //   adminId,
// //   info,
// //   requestText,
// //   setRequestText,
// // }) => {
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState<string | null>(null);
// //   const token = getToken();

// //   const handleSubmit = async () => {
// //     if (!requestText.trim()) return;
// //     setLoading(true);
// //     setError(null);

// //     try {
// //       const data: RequestData = {
// //         admin_id: adminId, // Use the passed adminId
// //         req_desc: requestText,
// //       };
// //       await getrequestdata(adminId, token, data);
// //       onSubmit(requestText); // Call parent onSubmit for further handling
// //       setRequestText("");
// //       onClose();
// //     } catch (err) {
// //       console.error("Error submitting edit request:", err);
// //       setError("Failed to submit request. Please try again.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <Dialog
// //       open={open}
// //       onClose={onClose}
// //       fullWidth
// //       maxWidth="sm"
// //       PaperProps={{
// //         sx: {
// //           width: "800px !important",
// //           maxWidth: "800px !important",
// //           borderRadius: "10px",
// //         },
// //       }}
// //     >
// //       <DialogTitle
// //         sx={{
// //           fontWeight: 500,
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           fontSize: "24px",
// //         }}
// //       >
// //         Edit request for personal information
// //         <IconButton onClick={onClose} disabled={loading}>
// //           <CloseIcon
// //             sx={{
// //               width: "15px",
// //               border: "1px solid #000",
// //               borderRadius: "50%",
// //               height: "15px",
// //               color: "#000",
// //             }}
// //           />
// //         </IconButton>
// //       </DialogTitle>

// //       <DialogContent>
// //         {error && (
// //           <Typography color="error" sx={{ mb: 2 }}>
// //             {error}
// //           </Typography>
// //         )}
// //         <Grid container spacing={2}>
// //           <Grid item xs={6}>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
// //             >
// //               First Name: <b>{info.firstName}</b>
// //             </Typography>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
// //             >
// //               Mobile Number: <b>{info.mobile}</b>
// //             </Typography>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
// //             >
// //               Team: <b>{info.team}</b>
// //             </Typography>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
// //             >
// //               Module Owner: <b>{info.owner}</b>
// //             </Typography>
// //           </Grid>
// //           <Grid item xs={6}>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
// //             >
// //               Last Name: <b>{info.lastName}</b>
// //             </Typography>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
// //             >
// //               Company Email: <b>{info.email}</b>
// //             </Typography>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
// //             >
// //               Module Access: <b>{info.access}</b>
// //             </Typography>
// //           </Grid>
// //         </Grid>

// //         <Box mt={3}>
// //           <Box sx={{ display: "flex", justifyContent: "space-between" }}>
// //             <Typography variant="body2" mb={1}>
// //               Write your request*
// //             </Typography>
// //             <Typography variant="caption" color="text.secondary">
// //               {requestText.length}/200
// //             </Typography>
// //           </Box>
// //           <TextField
// //             fullWidth
// //             multiline
// //             minRows={4}
// //             placeholder="Please list the edits you would like to request here."
// //             value={requestText}
// //             inputProps={{ maxLength: 200 }}
// //             onChange={(e) => setRequestText(e.target.value)}
// //             sx={{ background: "#F3F4F6" }}
// //             disabled={loading}
// //           />
// //         </Box>
// //       </DialogContent>

// //       <DialogActions
// //         sx={{
// //           px: 3,
// //           pb: 2,
// //           display: "flex",
// //           justifyContent: "space-between",
// //           width: "100%",
// //         }}
// //       >
// //         <Button
// //           variant="outlined"
// //           onClick={onClose}
// //           sx={{ width: "50%", color: "#7D7E7F", borderColor: "1px solid #7D7E7F" }}
// //           disabled={loading}
// //         >
// //           Back
// //         </Button>
// //         <Button
// //           variant="contained"
// //           disabled={!requestText.trim() || loading}
// //           onClick={handleSubmit}
// //           sx={{ width: "50%", background: "#C8172F" }}
// //         >
// //           {loading ? "Submitting..." : "Submit"}
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default EditRequest;
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  TextField,
  Button,
  Grid,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getrequestdata } from "./api"; // Adjust path to your api.ts
import { getToken } from "../../utils/utils";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import { useNavigate } from "react-router-dom";

interface RequestData {
  admin_id: string;
  req_desc: string;
}

interface EditRequestDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (request: string) => void;
  adminId: string; // Added adminId prop
  info: {
    firstName: string;
    lastName: string;
    mobile: string;
    email: string;
    company_email_id:string,
    team: string;
    access: string;
    owner: string;
  };
  requestText: string;
  setRequestText: (value: string) => void;
}

const EditRequest: React.FC<EditRequestDialogProps> = ({
  open,
  onClose,
  onSubmit,
  adminId,
  info,
  requestText,
  setRequestText,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const token = getToken();
    const navigate = useNavigate();
  const { showAlert } = useAlert();
  const handleSubmit = async () => {
  if (!requestText.trim()) return;
  setLoading(true);
  setError(null);

  try {
    const data: RequestData = {
      admin_id: adminId,
      req_desc: requestText,
    };

    const response = await getrequestdata(adminId, token, data); // Store response

    onSubmit(requestText); // Call parent onSubmit for further handling
    setRequestText("");
    onClose();

    if (response.data.success === true) {
      showAlert("Team Member successfully Saved!", "success");
     
      setTimeout(() => window.location.reload(), 100);
    } else {
      showAlert('Failed to update approval status.');
    }
  }catch (error: any) {
  console.error("Error while saving team member:", error);

  let errorMessage = "Something went wrong while saving the request.";

  if (error.response && error.response.data) {
    // Try to extract your custom error message
    errorMessage = error.response.data.error || error.response.data.message || errorMessage;
  }

  showAlert(errorMessage, "error");
  setError(errorMessage);
} finally {
    setLoading(false);
  }
};


  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          width: "800px !important",
          maxWidth: "800px !important",
          borderRadius: "10px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 500,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "24px",
        }}
      >
        Edit request for personal information
        <IconButton onClick={onClose} disabled={loading}>
          <CloseIcon
            sx={{
              width: "15px",
              border: "1px solid #000",
              borderRadius: "50%",
              height: "15px",
              color: "#000",
            }}
          />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
            >
              First Name: <b>{info.firstName}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
            >
              Mobile Number: <b>{info.mobile}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
            >
              Team: <b>{info.team}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
            >
              Module Owner: <b>{info.owner}</b>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
            >
              Last Name: <b>{info.lastName}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
            >
              Company Email: <b>{info.company_email_id}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "14px", paddingBottom: "10px", color: "#494A4B" }}
            >
              Module Access: <b>{info.access}</b>
            </Typography>
          </Grid>
        </Grid>

        <Box mt={3}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" mb={1}>
              Write your request*
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {requestText.length}/200
            </Typography>
          </Box>
          <TextField
            fullWidth
            multiline
            minRows={4}
            placeholder="Please list the edits you would like to request here."
            value={requestText}
            inputProps={{ maxLength: 200 }}
            onChange={(e) => setRequestText(e.target.value)}
            sx={{ background: "#F3F4F6" }}
            disabled={loading}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2,
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ width: "50%", color: "#7D7E7F", borderColor: "1px solid #7D7E7F" }}
          disabled={loading}
        >
          Back
        </Button>
        <Button
          variant="contained"
          disabled={!requestText.trim() || loading}
          onClick={handleSubmit}
          sx={{ width: "50%", background: "#C8172F" }}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditRequest;